const DEFAULT_VERSION = 0;
export class ClientStorage {
    constructor(key, { isSessionOnly = false, noCache = false, version = DEFAULT_VERSION, } = {}) {
        this.key = key;
        this.cache = null;
        this.isCached = false;
        this.version = version;
        this.useCache = !noCache;
        this.storage = isSessionOnly ? sessionStorage : localStorage;
    }
    get() {
        if (!this.useCache) {
            return this.load();
        }
        if (this.isCached) {
            return deepClone(this.cache);
        }
        this.isCached = true;
        this.cache = this.load();
        return this.cache;
    }
    set(json) {
        this.save(json);
    }
    save(json) {
        const data = { data: json, version: this.version };
        if (this.useCache) {
            this.cache = json;
            this.isCached = true;
        }
        this.storage.setItem(this.key, JSON.stringify(data));
    }
    load() {
        const json = this.storage.getItem(this.key);
        if (!json) {
            return null;
        }
        const content = JSON.parse(json);
        if (content.version !== this.version) {
            this.reset();
            return null;
        }
        if (this.useCache) {
            this.cache = deepClone(content.data);
            this.isCached = true;
        }
        return content.data;
    }
    loadAsync(delay = 100) {
        return new Promise(resolve => {
            setTimeout(() => resolve(this.load()), delay);
        });
    }
    clear() {
        const value = this.get();
        this.reset();
        return value;
    }
    reset() {
        this.storage.removeItem(this.key);
        this.cache = null;
        this.isCached = true;
    }
}
function deepClone(target) {
    return typeof target === 'object'
        ? JSON.parse(JSON.stringify(target))
        : target;
}
//# sourceMappingURL=ClientStorage.js.map